// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@awc/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { rfqQuoteDetailsInformationStyles } from "@awc/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsInformation";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

rfqQuoteDetailsInformationStyles.detailsGridContainer = {
    gap: 0,
    css: css`
        margin-bottom: 20px;
    `,
};

rfqQuoteDetailsInformationStyles.expirationDateGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        &&& {
            margin-bottom: 10px;
        }
    `,
};

rfqQuoteDetailsInformationStyles.expirationDateDatePicker = {
    cssOverrides: {
        datePicker: css`
            width: 200px;
        `,
        formField: css`
            label {
                font-size: ${fontConfig.fontSize.small}px;
                line-height: ${fontConfig.lineHeight.small};
                font-weight: bold;
                margin-right: 4px;
            }
        `,
    },
};

rfqQuoteDetailsInformationStyles.expirationDateTextGridItem = {
    width: [12, 12, 6, 12, 12],
    css: css`
        &&& {
            margin-bottom: 6px;
        }
        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
        ${xScreen("lte", "sm")} {
            flex-direction: row;
        }
    `,
};

rfqQuoteDetailsInformationStyles.expirationDateLabelText = rfqQuoteDetailsInformationStyles.dateLabelText = {
    ...mergeWithCss(xOrderInformationStyles.labelWithDots, {
        css: css`
            margin-bottom: 6px;
        `,
    }),
    ...{ as: "h2" },
};

rfqQuoteDetailsInformationStyles.expirationDateValue = rfqQuoteDetailsInformationStyles.dateValue = {
    ...mergeWithCss(xOrderInformationStyles.value, {
        css: css`
            margin-bottom: 6px;
        `,
    }),
};

rfqQuoteDetailsInformationStyles.headingAndTextData = {
    ...xOrderInformationStyles.headingAndTextStyles,
};

rfqQuoteDetailsInformationStyles.jobNameGridItem =
    rfqQuoteDetailsInformationStyles.salesRepGridItem =
    rfqQuoteDetailsInformationStyles.userGridItem =
    rfqQuoteDetailsInformationStyles.statusGridItem =
    rfqQuoteDetailsInformationStyles.customerGridItem =
    rfqQuoteDetailsInformationStyles.shipToGridItem =
        {
            width: 12,
        };

rfqQuoteDetailsInformationStyles.dateGridItem = {
    width: 12,
    css: css`
        margin-bottom: 6px;
    `,
};

rfqQuoteDetailsInformationStyles.notesGridItem = {
    width: 12,
};

rfqQuoteDetailsInformationStyles.notesHeadingAndText = {
    heading: {
        size: 14,
        lineHeight: "22px",
        weight: "bold",
        transform: "none",
        css: css`
            margin-right: 4px;
        `,
    },
    wrapper: {
        css: css`
            flex-direction: column;
        `,
    },
    text: {
        size: 14,
        lineHeight: "22px",
        css: css`
            &:empty:after {
                content: "- -";
            }
        `,
    },
};
